




































import { Component, Vue, Prop } from 'vue-property-decorator';
import VoerroTagsInput from '@voerro/vue-tagsinput';
import { ValidationProvider } from 'vee-validate';

@Component({
  components: {
    'tag-input': VoerroTagsInput,
  },
})
export default class TagInput extends Vue {
  @Prop(String) placeholder!: string;
  @Prop(String) subtitle!: string;
  @Prop([Object, String, Array]) value!: unknown;
  @Prop(String) label!: string;
  @Prop(String) variant!: string;
  @Prop(String) displayLabel!: string;
  @Prop(Boolean) loading!: boolean;
  @Prop(Boolean) disabled!: boolean;
  @Prop(Boolean) multiple!: boolean;
  @Prop({ type: Boolean, default: false }) commaSeparator!: boolean;
  @Prop(String) trackBy!: string;
  @Prop(String) readonly name!: string;
  @Prop(String) readonly rules!: string;
  @Prop(String) readonly vid!: string;
  @Prop({ default: '' }) readonly error!: string;
  @Prop({ default: 'text' }) readonly type!: string;
  @Prop(Object) readonly customErrorMessages: undefined | { [key: string]: string };

  $refs!: {
    tagInput: TagInput;
    validator: InstanceType<typeof ValidationProvider>;
  }

  validate() {
    const values = (this.value as { key: string; value: string }[]).map((e) => e.value);
    this.$refs.validator.validate(values);
  }

  mounted() {
    if (this.type === 'number') {
      const input = this.$refs.tagInput.$el.getElementsByTagName('input');
      input[0].oninput = (event: Event) => {
        input[0].value = (event.target as HTMLInputElement).value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
      };
    }
  }

  get inputVal() {
    return this.value;
  }

  set inputVal(val) {
    if (Array.isArray(val)) {
      val.forEach((e) => {
        e.value = e.value.replace(/<|>/g, '');
      });
    }
    this.$emit('input', val);
  }
}
